// Keeps Microsoft Office add-on lines tied to their computer in the cart.
// Each Office line carries the computer's variant id in the hidden _office_for
// property. When the computer is removed or its quantity drops, the Office
// line is reduced or removed to match.
(() => {
  const LINK_PROPERTY = '_office_for';
  const MAX_FIXES_IN_A_ROW = 10;
  let fixesInARow = 0;
  let running = false;

  // Returns the first Office line that exceeds its computer's quantity, as { line, quantity }.
  function findExcessOfficeLine(items) {
    const remaining = {};
    items.forEach((item) => {
      remaining[item.variant_id] = (remaining[item.variant_id] || 0) + item.quantity;
    });

    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      const computerId = item.properties && item.properties[LINK_PROPERTY];
      if (!computerId) continue;

      const allowed = Math.min(item.quantity, remaining[computerId] || 0);
      remaining[computerId] = (remaining[computerId] || 0) - allowed;
      if (allowed < item.quantity) return { line: index + 1, quantity: allowed };
    }
    return null;
  }

  async function reconcileOfficeLines() {
    if (running || fixesInARow >= MAX_FIXES_IN_A_ROW) return;
    running = true;

    try {
      const cart = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const fix = findExcessOfficeLine(cart.items || []);
      if (!fix) {
        fixesInARow = 0;
        return;
      }

      fixesInARow += 1;
      const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        // Re-renders the cart and publishes cartUpdate, which runs this check again.
        cartItems.updateQuantity(fix.line, fix.quantity);
      } else {
        await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: JSON.stringify(fix) });
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'office-addon' });
      }
    } catch (error) {
      console.error(error);
    } finally {
      running = false;
    }
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcileOfficeLines());
  if (window.officeAddonInCart) reconcileOfficeLines();
})();
